/**
 * Maps a failed password-grant response to the message the user sees.
 *
 * Sign-in posts straight to GoTrue's token endpoint (see passwordGrant in
 * store/useAppStore.ts), so this receives the raw JSON body. It exists because
 * that function collapses the body to a single string — the branch has to happen
 * before `error_code` is thrown away.
 */

export const UNCONFIRMED_EMAIL_MESSAGE = 'Confirm your account first — check your email.';

/**
 * Two ways to spot the unconfirmed case, deliberately. The live dev project
 * returns `error_code: 'email_not_confirmed'`; older GoTrue returns
 * `{"error":"invalid_grant","error_description":"Email not confirmed"}` with no
 * error_code at all. Production's version is unconfirmed, and matching only the
 * first would silently fall through to "Invalid login credentials" — the exact
 * bug this exists to fix.
 */
export function signInErrorMessage(body: Record<string, unknown>, status: number): string {
  const fallback = (body.error_description ?? body.msg ?? body.error ??
    `sign-in failed (HTTP ${status})`) as string;

  if (body.error_code === 'email_not_confirmed') return UNCONFIRMED_EMAIL_MESSAGE;
  if (/email not confirmed/i.test(fallback)) return UNCONFIRMED_EMAIL_MESSAGE;

  return fallback;
}
